import { getAuthToken } from '@/auth';
import { getApiV1UsersUserIdCarouselsJumpBackIn } from '@/open-api/users/users';

import type { JumpBackInTile } from '@/open-api/model';
import type { Carousel, Tile } from '@/types/carousel';

const MAX_TILES = 10;

/** Shown for content without an image, e.g. a playlist with no cover. */
export const JUMP_BACK_IN_PLACEHOLDER_IMAGE =
  'https://cdn.uppbeat.io/images/style-placeholder.png';

export const mapJumpBackInTile = (
  tile: NonNullable<JumpBackInTile>,
  index: number
): Tile => ({
  id: index,
  name: tile.name ?? '',
  order: index,
  slug: '',
  tile_image: tile.image ?? JUMP_BACK_IN_PLACEHOLDER_IMAGE,
  url: tile.url,
  type: tile.type,
  description: tile.description,
  ...(tile.displayPicture && {
    profile_picture: tile.displayPicture,
  }),
});

export const getJumpBackInCarousels = async (
  userId?: number
): Promise<Carousel[]> => {
  // Signed-out visitors have no history, so don't ask the API (it would 401).
  if (!(userId && getAuthToken())) {
    return [];
  }

  let tiles: JumpBackInTile[];

  try {
    const data = await getApiV1UsersUserIdCarouselsJumpBackIn(userId, {
      Limit: MAX_TILES,
    });
    tiles = data?.tiles ?? [];
  } catch (err) {
    console.error(err);

    return [];
  }

  return [
    {
      name: 'Jump back in',
      order: 1,
      tiles: tiles
        .filter((tile): tile is NonNullable<JumpBackInTile> => tile !== null)
        .map(mapJumpBackInTile),
    },
  ];
};
